import Forgot from "../pages/auth/Forgot.jsx";
import Login from "../pages/auth/Login.jsx";
import Otp from "../pages/auth/Otp.jsx";
import Register from "../pages/auth/Register.jsx";
import ResetPassword from "../pages/auth/ResetPassword.jsx";
import AdminLogin from "../pages/auth/AdminLogin.jsx";
import TFAuthenticator from "../pages/auth/TFAuthenticator.jsx";
import Communication from "../pages/communication/Communication.jsx";
import Dashboard from "../pages/dashboard/Dashboard.jsx";
import Trash from "../pages/documents/components/Trash.jsx";
import Documents from "../pages/documents/Documents.jsx";
import CreateFiles from "../pages/files/components/CreateFiles.jsx";
import QuestionAnswerFlow from "../pages/files/components/QuestionAnswerFlow.jsx";
import Files from "../pages/files/Files.jsx";
import Payments from "../pages/payments/Payments.jsx";
import About from "../pages/public/About.jsx";
import Contact from "../pages/public/Contact.jsx";
import PrivacyPolicy from "../pages/public/PrivacyPolicy.jsx";
import Settings from "../pages/settings/Settings.jsx";
import PaymentVerification from "../services/stripe/PaymentVerification.jsx";
import Activity from "../pages/activity/Activity.jsx";

export const initialRoutes = () => {
  const routes = [
    // ============ Auth ===============
    { path: "/login", type: "auth", component: Login, title: "Login" },
    { path: "/register", type: "auth", component: Register, title: "Register" },
    { path: "/otp", type: "auth", component: Otp, title: "Otp" },
    {
      path: "/authentication",
      type: "auth",
      component: TFAuthenticator,
      title: "Authentication",
    },
    {
      path: "/forget_password",
      type: "auth",
      component: Forgot,
      title: "ForgotPassword",
    },
    {
      path: "/change_password/:token",
      type: "auth",
      component: ResetPassword,
      title: "ResetPassword",
    },

    // ============ Public =============
    { path: "/admin_login", type: "public", component: AdminLogin },
    { path: "/about", type: "public", component: About },
    { path: "/contact", type: "public", component: Contact },
    { path: "/privacy_policy", type: "public", component: PrivacyPolicy },

    // ============ Privet ==============
    {
      path: "/dashboard",
      type: "private",
      component: Dashboard,
      title: "Dashboard",
    },
    { path: "/", type: "private", component: Dashboard, title: "Dashboard" },
    {
      path: "/document",
      type: "private",
      component: Documents,
      title: "Document",
    },
    {
      path: "/documents_trash",
      type: "private",
      component: Trash,
      title: "Trash",
    },
    { path: "/files", type: "private", component: Files, title: "Files" },
    // { path: "/create_files", type: "private", component: CreateFiles, title: "Files" },
    {
      path: "/file/:id",
      type: "private",
      component: QuestionAnswerFlow,
      title: "Files",
    },
    { path: "/chat", type: "private", component: Communication, title: "Chat" },

    { path: "/activity", type: "private", component: Activity, title: "Activity" },
    {
      path: "/settings",
      type: "private",
      component: Settings,
      title: "settings",
    },
    {
      path: "/payments",
      type: "private",
      component: Payments,
      title: "Payments Report",
    },
    {
      path: "/settings",
      type: "private",
      component: Settings,
      title: "settings",
    },

    {
      path: "payment_verification/:id",
      type: "private",
      component: PaymentVerification,
      title: "Payment Verification",
    },
  ];
  return routes;
};
